import React from "react";
import { StyledVideoSection } from "./ui";
import theme from "../../assets/ui/theme";

class VideoSection extends React.Component {
  state = {
    playVideo: false
  };

  constructor(props) {
    super(props);
    this.video = React.createRef();
  }

  componentDidMount() {
    window.innerWidth > parseInt(theme.queries.sl, 10) &&
      window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  pauseScrollEvent = () => {
    window.removeEventListener("scroll", this.handleScroll);
  };

  handleScroll = () => {
    const deviseHeight = window.innerHeight;
    const {
      height: elementHeight,
      top: elementTopPosition
    } = this.video.current.getBoundingClientRect();

    if (
      elementTopPosition < deviseHeight / 2 &&
      elementHeight + elementTopPosition > 100 &&
      this.video.current.paused
    ) {
      this.setState({ playVideo: true });
      this.video.current.play();
    } else if (
      elementHeight + elementTopPosition < 0 ||
      elementTopPosition - elementHeight > 0
    ) {
      this.setState({ playVideo: false });
      this.video.current.pause();
    }
  };

  render() {
    const { video } = this.props;

    return (
      <StyledVideoSection>
        <video
          id="background-video"
          ref={this.video}
          // muted
          controls
          onClick={this.pauseScrollEvent}
        >
          <source
            src={video ? video : "./Sample Videos 2.mp4"}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </StyledVideoSection>
    );
  }
}

export default VideoSection;
